export class Faq2Controller {
    static $inject = ['LoadingService', 'ApplicationService2', 'HostingService', 'ngToast', 'application', '$translate'];
    constructor(LoadingService, ApplicationService2, HostingService, ngToast, application, $translate) {
        'ngInject';
        this.LoadingService = LoadingService;
        this.ApplicationService2 = ApplicationService2;
        this.HostingService = HostingService;
        this.ngToast = ngToast;
        this.application = application;
        this.$translate = $translate;
        this.settings = this.application.applicationJson.settings;
        this.scoreThresholdPercentage = this.settings.scoreThreshold * 100;
        this.askFeedback = this.settings.askFeedback;
        this.positiveFeedback =
            this.settings.positiveFeedback ||
                $translate.instant('modules.application.detail.templates.faq2.usefulFeedback');
        this.negativeFeedback =
            this.settings.negativeFeedback ||
                $translate.instant('modules.application.detail.templates.faq2.notUsefulFeedback');
        this.thanksForFeedback = this.settings.thanksForFeedback;
        this.publishIfOffline();
    }
    $onInit() { }
    async publish() {
        this.application.applicationJson.settings = {
            scoreThreshold: this.scoreThresholdPercentage / 100,
            askFeedback: this.askFeedback,
            positiveFeedback: this.positiveFeedback,
            negativeFeedback: this.negativeFeedback,
            thanksForFeedback: this.thanksForFeedback,
        };
        this.LoadingService.startLoading();
        await this.HostingService.publish(this.application, this.application.template, this.application.applicationJson);
        try {
            const successMsg8 = await this.$translate('utils.successMsg.8');
            this.ngToast.success(successMsg8);
        }
        catch (err) {
            const errorMsg10 = await this.$translate('utils.errorMsg.10');
            this.ngToast.danger(errorMsg10);
            throw err;
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async publishIfOffline() {
        if (!await this.ApplicationService2.isOnline(this.application)) {
            this.publish();
        }
    }
}
// Explicit AngularJS DI annotation for minification safety
Faq2Controller.$inject = ['LoadingService', 'ApplicationService2', 'HostingService', 'ngToast', 'application', '$translate'];
